<template>
  <div id="realTimeData">
    <el-row class="full_height">
      <el-col :span="4" class="positon_relative">
        <el-menu
          class="nav_menu"
          text-color="#A7CCF6"
          active-text-color="#fff"
          :default-active='active'
          :default-openeds="openeds"
        >
          <el-submenu :index="item.code" v-for=" item  in menus" :key="item.code">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group v-for="child in item.childList" :key="child.code">
              <el-menu-item :index="child.code" @click="getMeasures(child)">
                {{
                  child.name
                }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="11111111" v-if="showTitle">
            <template slot="title">
              <i @click="navigate()" class="el-icon-location"></i>
              <span @click="navigate()">测量机器人自动监测系统</span>
            </template>
          </el-submenu>

        </el-menu>
      </el-col>
      <el-col :span="20" class="positon_relative">
        <div id="contentHight" class="tab_content">
          <el-row>
            <div id="modelPanel" class="model_panel">
              <div class="scroll_panel">
                <div class="scroll_panel">
                  <button class="btn" type="button" @click="saveView()">
                    <i class="el-icon-collection"></i>
                  </button>
                  <br/>
                  <button class="btn" type="button" @click="bigger()">
                    <i class="el-icon-plus"></i>
                  </button>
                  <br/>
                  <button class="btn" type="button" @click="smaller()">
                    <i class="el-icon-minus"></i>
                  </button>
                </div>
              </div>
              <div v-if="measureAlarmList.length != 0"
                   class="measureAlarmList">
                <div
                  v-for="data in measureAlarmList" :key="data.monitorObjNo"
                  @click="openAlarmList(data)">
                  {{ data.monitorObjName + data.measureAlias + "报警" }}
                </div>
              </div>
            </div>
          </el-row>
          <div class="downArrow" @click="changeView">
            <i class="el-icon-arrow-down" v-if="showMini"></i>
            <i class="el-icon-arrow-up" v-if="!showMini"></i>
          </div>

          <el-row class="miniContent" v-if="showMini">
            <el-carousel class="miniCar" ref="cardShow" :interval="5000" :autoplay="false"
                         indicator-position="none" v-if="rightShowType == 2">
              <el-carousel-item class="carouselItem">
                <template>
                  <div class="mini_chart_panel1" v-for="data in rightShowType2Arr">
                    <img src="../../assets/images/databg.png">
                    <div class="chart_content">
                      <el-row class="full_width"
                              style="padding: 2% 5%;font-size: 12px;display: flex;flex-direction: row; align-items: center">
                        <el-col :span="24">
                          {{ data.name }}
                        </el-col>
                      </el-row>
                      <el-row @click.native="openRightShowType2MainEcharts(data)">
                        <el-col
                          class="mini_chart1"
                          :id="'rightShowType2MiniEcharts' + data.measureGroupId">
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </template>
              </el-carousel-item>
            </el-carousel>


            <el-carousel class="miniCar" ref="cardShow" :interval="5000" :autoplay="false"
                         indicator-position="none" v-else>
              <el-carousel-item class="carouselItem" v-for="item in (Math.ceil(measures.length/10))"
                                :key="item">
                <template v-for="num in 10">
                  <div class="mini_chart_panel" :key="num" v-if="measures.length>((item-1)*10+num-1)">
                    <img src="../../assets/images/databg.png">
                    <div class="chart_content">
                      <el-row class="full_width "
                              style="padding: 5% 5%;font-size: 12px;display: flex;flex-direction: row; align-items: center">
                        <el-col :span="12">
                          {{ measures[((item - 1) * 10 + num - 1)].alias.split("(")[0] }}
                        </el-col>
                        <el-col :span="10">{{
                            measures[((item - 1) * 10 + num - 1)].measureNo
                          }}
                        </el-col>
                        <el-col :span="2">
                          <div
                            :id="`statusC${measures[((item - 1) * 10 + num - 1)].measureNo}`"
                            class="circularStatus"></div>
                        </el-col>
                        <el-col :span="2">
                          <el-checkbox class="poverClassFlag"
                                       @change.native="showPopover(((item-1)*10+num-1),$event)"></el-checkbox>
                        </el-col>
                      </el-row>
                      <el-row
                        @click.native="getChart(measures[((item - 1) * 10 + num - 1)],
                        measures[((item - 1) * 10 + num - 1)].measureNo,
                         measures[((item - 1) * 10 + num - 1)].measureInfo,
                         measures[((item - 1) * 10 + num - 1)].alarmDataJson)">
                        <el-col
                          class="mini_chart"
                          :id="'data'+measures[((item - 1) * 10 + num - 1)].measureNo">
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </template>
              </el-carousel-item>
            </el-carousel>
          </el-row>

        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="rightShowTypeDialogTitle"
      center
      top="5vh"
      :visible.sync="rightShowTypeDialogVisible"
      :modal-append-to-body='false'
      @opened="loadRightShowTypeEcharts"
      class="loadDialog"
      width="60%">
      <div class="showtype2title1"
           v-if="showType2MainEchartsData.dayCalcedShiftValues && showType2MainEchartsData.dayCalcedShiftValues.length != 0">
        <div>
          当天总计位移x：{{ showType2MainEchartsData.dayCalcedShiftValues[0] }}
        </div>
        <div>
          当天总计位移y：{{ showType2MainEchartsData.dayCalcedShiftValues[1] }}
        </div>
        <div style="word-break: keep-all">
          当天总计位移z：{{ showType2MainEchartsData.dayCalcedShiftValues[2] }}
        </div>
      </div>
      <div class="showtype2title2"
           v-if="showType2MainEchartsData.initCalcedShiftValues && showType2MainEchartsData.initCalcedShiftValues.length != 0">
        <div>
          初始总计位移x：{{ showType2MainEchartsData.initCalcedShiftValues[0] }}
        </div>
        <div>
          初始总计位移y：{{ showType2MainEchartsData.initCalcedShiftValues[1] }}
        </div>
        <div>
          初始总计位移z：{{ showType2MainEchartsData.initCalcedShiftValues[2] }}
        </div>
      </div>
      <div style="height: 65vh;width: 99%" id="mainChart"></div>
      <div class="changeLine"></div>
    </el-dialog>
    <el-dialog
      :title=lableName
      center
      :visible.sync="chartDialogVisible"
      :modal-append-to-body='false'
      @opened="loadChartData"
      class="loadDialog"
      width="50%">
      <div style="height:  33rem;width: 99%" id="mainChart"></div>
      <div class="changeLine"></div>
    </el-dialog>
    <el-dialog
      title="报警信息详情"
      :visible.sync="showMeasureAlarmList"
      :modal-append-to-body='false'
      :close-on-click-modal="false"
      center
      width="40%"
    >
      <div class="measureAlarmListInfo">
        <div v-for="(data,index) in measureAlarmListInfo" :key="index">
          {{ data.alarmLevel + "级报警：" + data.alarmTime + " " + data.suffixMsg }}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import $ from "jquery"
import ChartModal from "./ChartModal"
import WindDirectionModal from "./WindDirectionModal"
// 声明Viewer及其它
let viewer3D = null;
let app = null;

export default {
  name: "RealTimeMonitor",
  components: {
    ChartModal,
    WindDirectionModal,
    // HomeFooter,
  },
  data() {
    return {
      menus: null,//左侧菜单数组
      active: "", //默认高亮
      openeds: [], //默认展开
      url: null,//静态文件前缀
      path: null,//模型bimtoken或者图片的路径
      measures: [],//测点信息数组
      hoverList: [],
      chooseID: "",//选中点
      measureNos: [],//测点编号集合
      allPoint: [],//测点ID集合
      infoPics: [],//预报警按钮颜色
      popoverStatus: [],//popover显示状态
      systemType: "0",//系统类型
      viewer3D: null,
      objectMap: {},//objectid与measure的映射关系
      loadComplete: false,//bim模型加载完成3
      drawableContainer: null,//测点画布控件
      // webSocketUrl: "ws://192.168.8.68:60000/monitor/imserver/", //本地
      // webSocketUrl: "ws://110.189.155.28:9000/monitor/imserver/", //线上
      webSocketUrl: localStorage.getItem("websocketUrl"), //本地 陈忠
      socket: "",
      currentpoint: "", //是否自定义展示
      meassureData: {},//监测数据保存的对象
      charts: {},//保存图表实例
      chartDialogVisible: false,//弹窗
      mainMeasureNo: null,//弹窗目前的测点
      markLineData: [],
      lableName: "",//
      uniName: "",
      norValue: "",
      bimfacePopoverId: {},//存放bimface弹框id
      isFullScreen: false,//是否设置全屏
      showMini: true, //是否展示首页下方小图标
      StanderNum: "",
      showTitle: false,
      unitObj: {},
      measureAlarmList: [],
      showMeasureAlarmList: false,
      measureAlarmListInfo: [],
      measureAlarmListSettime: null,
      rightShowType: 1,
      showType2Echarts: null,
      showType2MainEchartsData: {},
      rightShowTypeDialogTitle: "",
      rightShowTypeDialogVisible: false,
      rightShowType2Arr: [],
      rightShowTypeDialogObj: {}
    }
  },
  watch: {},
  computed: {},
  mounted: function() {
    if (localStorage.getItem("mainId") == "92") {
      this.showTitle = true
    }
    this.currentpoint = localStorage.getItem("currentpoint");
    this.url = localStorage.getItem("url")
    this.path = localStorage.getItem("path")
    this.systemType = localStorage.getItem("systemType");
    this.getMenuItem()
    setTimeout(() => {
      let bimfaceOption = new BimfaceSDKLoaderConfig();
      bimfaceOption.viewToken = this.path;
      BimfaceSDKLoader.load(bimfaceOption, this.bimfaceSuccess, this.bimfaceFail);
    }, 500)
    // 刚进页面展示所有折线图
    this.getAlarmList()
    //socket监听
    this.socketInit();
  },
  beforeDestroy() {
    clearTimeout(this.measureAlarmListSettime)
  },
  methods: {
    openAlarmList(data) {
      this.measureAlarmListInfo = data.alarmInfoList
      this.showMeasureAlarmList = true
    },
    getAlarmList() {
      this.$axios.post("/api/monitor/realTimeMonitor/measureAlarmListWithInfo", {}).then(res => {
        if (res.data.status == 200) {
          this.measureAlarmList = res.data.datas.values
          if (this.measureAlarmList.length != 0) {
            this.measureAlarmListSettime = setTimeout(() => {
              this.isReadAlarmInfo()
            }, 1000 * 10)
          }
        }
      })
    },
    isReadAlarmInfo() {
      this.$axios.post("/api/monitor/realTimeMonitor/readProjectAlarmInfo", {}).then(res => {

      })
    },
    //新增机器人 跳转
    navigate() {
      window.open("http://data.whunime.com/");
    },
    //获取左侧菜单栏
    getMenuItem() {
      this.$axios.get("/api/monitor/project/measure/parameterSelection").then(res => {
        if (res.data.status == 200) {
          this.menus = res.data.datas.values;
          // let newArr = res.data.datas.values
          // let finalData = null;
          // for (let i = 0; i < newArr.length; i++) {
          //     if (newArr[i].name == "内部深层位移" || newArr[i].name == "内部位移") {
          //         this.menus[i].childList = [newArr[i].childList[0]]
          //     }
          //     if (newArr[i].name == "衬砌结构沉降" && newArr[i].code == "0402") {
          //         this.menus[i].name = "维护墙表面位移"
          //     }
          //     if (newArr[i].name == "应力/应变" && newArr[i].code == "0201") {
          //         this.menus[i].childList[0].name = "表贴应变传感器"
          //     }
          // }
          //导航栏存在参数的时候
          if (this.$route.query.monitorObjectCode) {
            this.menus.forEach(item => {
              if (item.code == this.$route.query.monitorObjectCode) {
                this.getMeasures(item);
                this.openeds = [item.code]
                this.active = this.$route.query.measureNo.slice(0, 6)
                //    打开大图
              }
            })
          } else if (this.$route.query.measurePart) {
            let monitorObjectCode = this.$route.query.measurePart.substring(0, 4)
            this.menus.forEach(item => {
              if (item.code == monitorObjectCode) {
                this.getMeasures(item);
                this.openeds = [item.code]
                //    打开大图
              }
            })
          } else {
            this.getMeasures("all");
            this.openeds = []
            this.active = ""
          }
        }
      });
    },
    /*下拉箭头*/
    changeView() {
      var contentHight = document.getElementById("contentHight").clientHeight
      var dramImg = document.getElementById("modelPanel") //echarts 大小
      var reallHight = document.getElementById("modelPanel").clientHeight
      if (reallHight == 400) {
        dramImg.style.height = contentHight - 16 + "px"
        this.showMini = false
      } else {
        dramImg.style.height = "400px"
        this.showMini = true
      }
      this.viewer3D.resize()
    },
    /*左右箭头方法*/
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
    /*BIM模型*/
    bimfaceSuccess(viewMetaData) {
      let appConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
      appConfig.domElement = document.getElementById("modelPanel");
      appConfig.Toolbars = [];   // 取消工具条
      appConfig.Buttons = [];
      let app = new Glodon.Bimface.Application.WebApplication3D(appConfig);
      this.viewer3D = app.getViewer();
      this.viewer3D.enableMouseHoverHighlight();
      this.viewer3D.hideViewHouse();
      this.viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, () => {
        this.loadComplete = true;
        let color = new Glodon.Web.Graphics.Color(0, 255, 0, 1);
        this.viewer3D.overrideComponentsColorById(this.allPoint, color);
        this.viewer3D.render();
        if (localStorage.getItem("currentpoint") !== "undefined") {
          setTimeout(() => {
            this.viewer3D.setCameraStatus(localStorage.getItem("currentpoint"))
          }, 500)
        }

      });
      /*hover自定义lable的显示隐藏*/
      var useID = null;
      var timeout = null;
      this.viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ComponentsHoverChanged, (objectData) => {
        if (!objectData.worldPosition) return;
        var flag = false;
        var config = new Glodon.Bimface.Plugins.Drawable.CustomItemConfig();
        for (var i = 0; i < this.measures.length; i++) {
          if (objectData.objectId == this.measures[i].modelObjectId) {
            flag = true;
            if (useID == objectData.objectId) {
              return; // 当前id就是正在展示的id不展示
            } else {
              this.measures.forEach(item => {
                if (item.modelObjectId == useID) {
                  this.removeMeasureInModel(item.measureNo)
                }
              })
              useID = objectData.objectId // 切换不一样的测点，还需要取消之前展示的
            }
            config.viewer = viewer3D;
            config.worldPosition = objectData.worldPosition;
            if (!flag) {
              return;
            }
            // 添加自定义标签之前，清除存在的cleartime
            if (timeout != null) {
              clearTimeout(timeout);
            }

            this.addMeasureToModel(objectData.objectId);

            var newArr = this.meassureData[this.measures[i].measureNo].dataArray
            var numberMeasure = this.measures[i].measureNo
            var lastArr = []
            var showArr = [];
            newArr.forEach(item => {
              lastArr.push(item.slice(-1))
            });
            lastArr.forEach(item => {
              showArr.push(item[0][1])
            })
            this.measures[i].newobj = showArr.join(",")
            showArr = [];
            lastArr = [];
            var colorArr = [];

            if (newArr.length !== 0) {
              newArr.forEach(item => {
                lastArr.push(item.slice(-1))
              });
              lastArr.forEach((item, index) => {
                this.measures.forEach(i => {
                  if (numberMeasure == i.measureNo) {

                    let alarmValueArr = []
                    let warnValueArr = []
                    if (JSON.parse(i.alarmDataJson).earlyWarningValue.split(",")[index].indexOf("~") != -1) {
                      warnValueArr = JSON.parse(i.alarmDataJson).earlyWarningValue.split(",")[index].split("~")
                    } else {
                      if (Number(JSON.parse(i.alarmDataJson).earlyWarningValue.split(",")[index]) > 0) {
                        warnValueArr = [Number(JSON.parse(i.alarmDataJson).earlyWarningValue.split(",")[index]) * -1, Number(JSON.parse(i.alarmDataJson).earlyWarningValue.split(",")[index])]
                      } else {
                        warnValueArr = [Number(JSON.parse(i.alarmDataJson).earlyWarningValue.split(",")[index]), Number(JSON.parse(i.alarmDataJson).earlyWarningValue.split(",")[index]) * -1]
                      }

                    }

                    if (JSON.parse(i.alarmDataJson).alarmValue.split(",")[index].indexOf("~") != -1) {
                      alarmValueArr = JSON.parse(i.alarmDataJson).alarmValue.split(",")[index].split("~")
                    } else {
                      if (Number(JSON.parse(i.alarmDataJson).alarmValue.split(",")[index]) > 0) {
                        alarmValueArr = [Number(JSON.parse(i.alarmDataJson).alarmValue.split(",")[index]) * -1, Number(JSON.parse(i.alarmDataJson).alarmValue.split(",")[index])]
                      } else {
                        alarmValueArr = [Number(JSON.parse(i.alarmDataJson).alarmValue.split(",")[index]), Number(JSON.parse(i.alarmDataJson).alarmValue.split(",")[index]) * -1]
                      }

                    }

                    // 值大于预警的第一个且小于报警的第一个值或者值大于报警的第二个值小于预警第二个值
                    if ((Number(item[0][1]) > warnValueArr[0] && Number(item[0][1]) < alarmValueArr[0]) || (Number(item[0][1]) > alarmValueArr[1] && Number(item[0][1]) < warnValueArr[1])) {
                      colorArr.push("red")
                    }

                    // 值小于预警第一个值，大于预警第二个值
                    if (Number(item[0][1]) <= warnValueArr[0] && Number(item[0][1]) >= warnValueArr[1]) {
                      colorArr.push("yellow")
                    }

                    // 值大于报警第一个值，小于报警第二个值
                    if (Number(item[0][1]) >= alarmValueArr[0] && Number(item[0][1]) <= alarmValueArr[1]) {
                      colorArr.push("green")
                    }
                  }
                })
              })
              this.drawBack(numberMeasure, colorArr)
            }
            timeout = setTimeout(() => {
              /*计时器 3s之后清除hover的效果*/
              this.measures.forEach(item => {
                if (item.modelObjectId == useID) {
                  this.removeMeasureInModel(item.measureNo)
                }
              })
              timeout = null;
              useID = null;
            }, 3000);
          }
        }
      })
      app.addView(viewMetaData.viewToken);
    },
    /*构建自定义label*/
    getCompontInfo(data) {
      let measure = this.objectMap[data.elementId];
      //新增部分
      this.hoverList = this.objectMap[data.elementId];

      let position = {
        x: (data.boundingBox.max.x + data.boundingBox.min.x) / 2,
        y: (data.boundingBox.max.y + data.boundingBox.min.y) / 2,
        z: (data.boundingBox.max.z + data.boundingBox.min.z) / 2
      };

      if (this.drawableContainer == null) {
        var drawableConfig = new Glodon.Bimface.Plugins.Drawable.DrawableContainerConfig();
        drawableConfig.viewer = this.viewer3D;
        this.drawableContainer = new Glodon.Bimface.Plugins.Drawable.DrawableContainer(drawableConfig);
      }
      var config = new Glodon.Bimface.Plugins.Drawable.CustomItemConfig();
      var content = document.createElement("div");
      content.innerHTML = "<div id=\"labalContent\" class=\"leadTips\">" +
        "<div style=\"width:49px;height:49px;\">" +
        "<img src=\"https://static.bimface.com/attach/24ce9654e88a4218908f46279e5c4b04_line.png\" height=\"35\" width=\"49\"/>"
        + "</div>" +
        "<div class=\"leadText\" id=\"measure" + measure.measureNo + "\">" +
        "" + "编号:" + measure.measureNo + "<br/>" + "名称:" + measure.measureInfo +
        "<br/>" + "参数:" + measure.pareCodeName +
        "<br/>" + "数据:" + measure.newobj +
        "<br/>" + "正常值:"
        + JSON.parse(measure.alarmDataJson).normalValue +
        "</div>" +
        "</div>"
      content.addEventListener("click", e => {
        this.getChart(measure, measure.measureNo, measure.measureInfo, measure.alarmDataJson)
      })
      config.content = content;
      config.viewer = this.viewer3D;
      config.worldPosition = position;
      //生成customItem实例
      var customItem = new Glodon.Bimface.Plugins.Drawable.CustomItem(config);
      if (this.bimfacePopoverId[measure.measureNo] != null) { //表示之前的还没有关闭，不能继续添加
        return;
      }
      this.bimfacePopoverId[measure.measureNo] = customItem.id;
      // 添加自定义标签
      this.drawableContainer.addItem(customItem);
    },
    getMeasures(child) {
      this.measures = [];
      if (child == "all") {
        this.rightShowType = 1
        this.$axios.get("/api/monitor/realTimeMonitor/getMeasuresByCode?code=" + child).then(res => {
          if (res.data.status == 200) {
            if (this.drawableContainer != null) {//清除3D已有标签
              this.drawableContainer.clear();
            }
            this.measures = res.data.datas.values;
            this.initMeasure();
            //初始化数据，用数组装是为了方便修改路径
            for (let i = 0; i < this.measures.length; i++) {
              this.infoPics.splice(i, 1, "success");
              this.popoverStatus.push(i, 1, false);
              this.objectMap[this.measures[i].modelObjectId] = this.measures[i];
              this.measureNos.splice(i, 1, this.measures[i].measureNo);
            }
            //获取最近的100条数据
            this.getRecentDatas();
            this.allPoint = [];
            this.measures.forEach(item => {
              this.allPoint.push(item.modelObjectId)
            })
            //高速socketserver获取的数据
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
              showClose: true
            });
          }
        })
        return
      }
      this.rightShowType = child.showType ? child.showType : 1
      this.$axios.get("/api/monitor/realTimeMonitor/getMeasuresByCode?code=" + child.code).then(res => {
        if (res.data.status == 200) {
          if (this.drawableContainer != null) {//清除3D已有标签
            this.drawableContainer.clear();
          }
          this.measures = res.data.datas.values;
          this.initMeasure();
          //初始化数据，用数组装是为了方便修改路径
          for (let i = 0; i < this.measures.length; i++) {
            this.infoPics.splice(i, 1, "success");
            this.popoverStatus.push(i, 1, false);
            this.objectMap[this.measures[i].modelObjectId] = this.measures[i];
            this.measureNos.splice(i, 1, this.measures[i].measureNo);
          }
          //获取最近的100条数据
          this.clickRecentDatas(child.code); // 获取数据且里面有右边小方块的echarts图生成函数
          this.allPoint = [];
          this.measures.forEach(item => {
            this.allPoint.push(item.modelObjectId)
          })
          //导航栏 存在参数的时候
          if (this.$route.query.monitorObjectCode) {
            this.measures.forEach(i => {
              if (i.measureNo == this.$route.query.measureNo) {
                setTimeout(() => {
                  this.getChart(i, i.measureNo, i.measureInfo, i.alarmDataJson)
                }, 800)
              }
            })
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
            showClose: true
          });
        }
      })
    },
    getRecentDatas() {
      let req = {
        measureNos: this.measureNos
      }
      this.$axios.post("/api/monitor/realTimeMonitor/getSpecialDatas", req).then(res => {
        let resDatas = res.data.datas.values;
        resDatas.forEach(resData => {
          let dataArray = [];
          let valShowIndex = []
          let unitAlias = []
          if (resData.valShowIndex) {
            valShowIndex = resData.valShowIndex.split(",")
          }
          if (resData.unitAlias) {
            unitAlias = resData.unitAlias.split(",")
          }
          for (let i = 0; i < resData.dataList.length; i++) {
            let dataValues = []
            //特殊情况处理，数据有问题的时候
            if (resData.dataList[i].dataJson.indexOf("NaN") !== -1) {
              for (let k in eval(resData.dataList[i].dataJson)) {
                dataValues[k] = ""
              }
            } else {
              dataValues = JSON.parse(resData.dataList[i].dataJson);
            }

            if (valShowIndex.length !== 0) {
              for (let j = 0; j < valShowIndex.length; j++) {
                if (dataArray[valShowIndex[j]] == null) {
                  dataArray[valShowIndex[j]] = [];
                }
                dataArray[valShowIndex[j]].push([this.formatDate(resData.dataList[i].timeTime), dataValues[valShowIndex[j]]]);
              }
            } else {
              for (let j = 0; j < dataValues.length; j++) {
                if (dataArray[j] == null) {
                  dataArray[j] = [];
                }
                dataArray[j].push([this.formatDate(resData.dataList[i].timeTime), dataValues[j]]);
              }
            }

          }
          delete resData.dataList
          this.meassureData[resData.measureNo] = {
            dataArray: dataArray,
            resData: resData
          }
        });
        for (let key in this.meassureData) {
          this.drawChart(key)
          this.showStatus(key)
        }
        this.send(this.measureNos);
      })
    },
    //点击侧边栏获取数据
    clickRecentDatas(code) {
      if (this.rightShowType == 2) {
        let req = {
          monitorObjNo: code,
          start: new Date().format("yyyy-MM-dd")
        }
        this.$axios.post("/api/monitor/realTimeMonitor/getHoleDatas", req).then(res => {
          let data = res.data
          if (data.status == 200) {
            if (data.datas.values && data.datas.values.length != 0) {
              this.rightShowType2Arr = data.datas.values
              this.drawShowType2Chart()
            }
          } else {
            this.$message({
              type: "error",
              message: data.message
            });
          }
        })
      } else {
        let req = {
          monitorObjNo: code
        }
        this.$axios.post("/api/monitor/realTimeMonitor/getSpecialDatas", req).then(res => {
          let resDatas = res.data.datas.values;
          resDatas.forEach(resData => {
            let dataArray = [];
            let valShowIndex = []
            let unitAlias = []
            if (resData.valShowIndex) {
              valShowIndex = resData.valShowIndex.split(",")
            }
            if (resData.unitAlias) {
              unitAlias = resData.unitAlias.split(",")
            }
            for (let i = 0; i < resData.dataList.length; i++) {
              let dataValues = []
              //特殊情况处理，数据有问题的时候
              if (resData.dataList[i].dataJson.indexOf("NaN") !== -1) {
                for (let k in eval(resData.dataList[i].dataJson)) {
                  dataValues[k] = ""
                }
              } else {
                dataValues = JSON.parse(resData.dataList[i].dataJson);
              }

              if (valShowIndex.length !== 0) {
                for (let j = 0; j < valShowIndex.length; j++) {
                  if (dataArray[valShowIndex[j]] == null) {
                    dataArray[valShowIndex[j]] = [];
                  }
                  dataArray[valShowIndex[j]].push([this.formatDate(resData.dataList[i].timeTime), dataValues[valShowIndex[j]]]);
                }
              } else {
                for (let j = 0; j < dataValues.length; j++) {
                  if (dataArray[j] == null) {
                    dataArray[j] = [];
                  }
                  dataArray[j].push([this.formatDate(resData.dataList[i].timeTime), dataValues[j]]);
                }
              }
            }
            delete resData.dataList
            this.meassureData[resData.measureNo] = {
              dataArray: dataArray,
              resData: resData
            }
          });
          for (let key in this.meassureData) {
            this.drawChart(key)
            this.showStatus(key)
          }
          this.send(this.measureNos);
        })
      }
    },
    //添加模型中自定义测点lable
    addMeasureToModel(modelObjectId) {
      this.viewer3D.getComponentProperty(modelObjectId, this.getCompontInfo);
    },
    removeMeasureInModel(measureNo) {
      if (this.drawableContainer && this.bimfacePopoverId && this.bimfacePopoverId[measureNo]) {
        this.drawableContainer.removeItemById(this.bimfacePopoverId[measureNo]);
        delete this.bimfacePopoverId[measureNo];
      } else {
      }

    },
    /*选择勾选框*/
    showPopover(index, ele) {
      let statu = ele.target.checked;
      /*勾选时候显示数据*/
      if (statu) {
        let color = new Glodon.Web.Graphics.Color(220, 20, 60, 1);
        this.viewer3D.overrideComponentsColorById(this.measures[index].modelObjectId, color);
        var newArr = this.meassureData[this.measures[index].measureNo].dataArray
        var numberMeasure = this.measures[index].measureNo
        var lastArr = [];
        var showArr = [];
        newArr.forEach(item => {
          lastArr.push(item.slice(-1))
        });
        lastArr.forEach(item => {
          showArr.push(item[0][1])
        })
        this.measures[index].newobj = showArr.join(",")
        this.addMeasureToModel(this.measures[index].modelObjectId);
        showArr = [];
        lastArr = [];
        var colorArr = [];
        if (newArr.length !== 0) {
          newArr.forEach(item => {
            lastArr.push(item.slice(-1))
          });
          for (let index = 0; index < lastArr.length; index++) {
            for (let j = 0; j < this.measures.length; j++) {
              if (numberMeasure === this.measures[j].measureNo) {


                let alarmValueArr = []
                let warnValueArr = []
                if (JSON.parse(this.measures[j].alarmDataJson).earlyWarningValue.split(",")[index].indexOf("~") != -1) {
                  warnValueArr = JSON.parse(this.measures[j].alarmDataJson).earlyWarningValue.split(",")[index].split("~")
                } else {
                  if (Number(JSON.parse(this.measures[j].alarmDataJson).earlyWarningValue.split(",")[index]) > 0) {
                    warnValueArr = [Number(JSON.parse(this.measures[j].alarmDataJson).earlyWarningValue.split(",")[index]) * -1, Number(JSON.parse(this.measures[j].alarmDataJson).earlyWarningValue.split(",")[index])]
                  } else {
                    warnValueArr = [Number(JSON.parse(this.measures[j].alarmDataJson).earlyWarningValue.split(",")[index]), Number(JSON.parse(this.measures[j].alarmDataJson).earlyWarningValue.split(",")[index]) * -1]
                  }

                }

                if (JSON.parse(this.measures[j].alarmDataJson).alarmValue.split(",")[index].indexOf("~") != -1) {
                  alarmValueArr = JSON.parse(this.measures[j].alarmDataJson).alarmValue.split(",")[index].split("~")
                } else {
                  if (Number(JSON.parse(this.measures[j].alarmDataJson).alarmValue.split(",")[index]) > 0) {
                    alarmValueArr = [Number(JSON.parse(this.measures[j].alarmDataJson).alarmValue.split(",")[index]) * -1, Number(JSON.parse(this.measures[j].alarmDataJson).alarmValue.split(",")[index])]
                  } else {
                    alarmValueArr = [Number(JSON.parse(this.measures[j].alarmDataJson).alarmValue.split(",")[index]), Number(JSON.parse(this.measures[j].alarmDataJson).alarmValue.split(",")[index]) * -1]
                  }

                }

                // 值大于预警的第一个且小于报警的第一个值或者值大于报警的第二个值小于预警第二个值
                if ((Number(lastArr[index][0][1]) > warnValueArr[0] && Number(lastArr[index][0][1]) < alarmValueArr[0]) || (Number(lastArr[index][0][1]) > alarmValueArr[1] && Number(lastArr[index][0][1]) < warnValueArr[1])) {
                  colorArr.push("red")
                }

                // 值小于预警第一个值，大于预警第二个值
                if (Number(lastArr[index][0][1]) <= warnValueArr[0] && Number(lastArr[index][0][1]) >= warnValueArr[1]) {
                  colorArr.push("yellow")
                }

                // 值大于报警第一个值，小于报警第二个值
                if (Number(lastArr[index][0][1]) >= alarmValueArr[0] && Number(lastArr[index][0][1]) <= alarmValueArr[1]) {
                  colorArr.push("green")
                }
              }
            }
          }
          this.drawBack(numberMeasure, colorArr)
        }
      } else {
        this.removeMeasureInModel(this.measures[index].measureNo);
      }
    },
    /*绘制自定义label背景颜色*/
    drawBack(numberMeasure, colorArr) {
      this.measures.forEach(i => {
        if (numberMeasure === i.measureNo) {
          if (colorArr.indexOf("red") !== -1) {
            setTimeout(() => {
              $("#measure" + i.measureNo).css("background", "red")
            }, 250)
          } else if (colorArr.indexOf("yellow") !== -1) {
            setTimeout(() => {
              $("#measure" + i.measureNo).css("background", "#DDAA00")
            }, 250)
          } else {
            setTimeout(() => {
              $("#measure" + i.measureNo).css("background", "green")
            }, 250)
          }
        }
      })
    },
    //websocket相关方法
    socketInit: function() {
      if (typeof (WebSocket) === "undefined") {
        this.$message({
          type: "error",
          message: "浏览器不支持socket",
          showClose: true
        });
      } else {
        // 实例化socket
        // "ws://detect.scentralit.com:9000/monitor/imserver"
        this.socket = new WebSocket((this.webSocketUrl != "undefined" && this.webSocketUrl != "" ? this.webSocketUrl : "ws://detect.scentralit.com:9000/monitor/imserver") + "/" + localStorage.getItem("token") + "?token=" + localStorage.getItem("token"))
        // 监听socket连接
        this.socket.onopen = this.socketOpen
        // 监听socket错误信息
        this.socket.onerror = this.socketError
        // 监听socket消息
        this.socket.onmessage = this.getMessage
      }
    },
    socketOpen: function() {
      this.$message({
        type: "success",
        message: "socket连接成功",
        showClose: true
      });
    },
    socketError: function() {
      this.$message({
        type: "error",
        message: "socket连接失败",
        showClose: true
      });
    },
    getMessage: function(msg) {
      let newPromise = new Promise((resolve) => {
        resolve();
      });
      newPromise.then(() => {
        if (!msg.data) {
          return;
        }
        if (msg.data == "连接成功") {
          return;
        }
        let data = JSON.parse(msg.data)
        if (data.fromUserId) {
          return;
        }

        let gettype = Object.prototype.toString

        if (gettype.call(data).indexOf("Object") != -1) { // 如果返回的是对象
          if (!JSON.parse(data.dataJson)) {
            return;
          }
          if (JSON.parse(data.dataJson).length == 0) {
            return;
          }
          let dataJson = JSON.parse(data.dataJson)
          let d = new Date(data.dataTime);
          let dataArray = [];
          if (this.meassureData[data.measureNo].resData.valShowIndex) {
            let valShowIndex = this.meassureData[data.measureNo].resData.valShowIndex
            if (this.meassureData[data.measureNo].dataArray[valShowIndex].length > 100) {
              this.meassureData[data.measureNo].dataArray[valShowIndex].shift();
            }
            this.meassureData[data.measureNo].dataArray[valShowIndex].push([this.formatDate(d), dataJson[valShowIndex]])
          } else {
            for (let j = 0; j < dataJson.length; j++) {
              if (dataArray[j] == null) {
                dataArray[j] = [];
              }
              if (this.meassureData[data.measureNo].dataArray[j].length > 100) {
                this.meassureData[data.measureNo].dataArray[j].shift();
              }
              this.meassureData[data.measureNo].dataArray[j].push([this.formatDate(d), dataJson[j]])
            }
          }

          //绘制miniEchart
          this.drawChart(data.measureNo);
          // this.getNjChart(data.alias)
          //判断监测点状态（正常、预警、报警）
          if (this.viewer3D) {
            this.showStatus(data.measureNo)
          }
          if (data.measureNo === this.mainMeasureNo) {
            this.loadChartData();
          }
        } else if (gettype.call(data).indexOf("Array") != -1) { // 如果返回的是数组
          if (data.length == 0) {
            return
          }
          data.forEach((item, index) => {
            if (this.meassureData[item.measureNo].dataArray.length == 0) {
              this.meassureData[item.measureNo].dataArray.push([])
            }
            if (this.meassureData[item.measureNo].dataArray[0].length > 200) {
              this.meassureData[item.measureNo].dataArray[0].shift();
            }
            let dataJson = JSON.parse(item.dataJson)
            this.meassureData[item.measureNo].dataArray[0].push([this.formatDate(item.dataTime), dataJson[0]])

            if (index == data.length - 1) {
              //绘制miniEchart
              this.drawChart(item.measureNo);
              // this.getNjChart(data.alias)
              //判断监测点状态（正常、预警、报警）
              if (this.viewer3D) {
                this.showStatus(item.measureNo)
              }
              if (item.measureNo === this.mainMeasureNo) {
                this.loadChartData();
              }
            }
          })
        }
      });
    },
    send: function(code) {
      let json = { "measureNo": code };
      this.socket.send(JSON.stringify(json))
    },
    close: function() {
      console.log("socket已经关闭")
    },
    saveView() {
      let camera = this.viewer3D.getCameraStatus()
      localStorage.setItem("currentpoint", JSON.stringify(camera))
      this.$axios.post("/api/monitor/realTimeMonitor/saveModelView", camera).then(res => {
        if (res.data.status == 200) {
          this.$message({
            type: "success",
            message: "视图保存成功",
            showClose: true
          });
          sessionStorage.setItem("isSave", true)
        }
      });
    },
    bigger() {
      this.viewer3D.zoomIn();
    },
    smaller() {
      this.viewer3D.zoomOut();
    },
    /*获取监测点状态*/
    showStatus(key) {
      if (!this.meassureData[key].dataArray) {
        return
      }
      let dataArray = this.meassureData[key].dataArray;
      let statusArr = []
      if (this.meassureData[key].resData.valShowIndex) {
        let valShowIndex = this.meassureData[key].resData.valShowIndex.split(",")
        for (let i = 0; i < valShowIndex.length; i++) {
          if (dataArray[valShowIndex[i]] == null) {
            continue
          }
          dataArray[valShowIndex[i]].forEach(item => {
            this.measures.forEach(j => {
              if (key == j.measureNo) {
                if (Number(parseInt(item[1])) > Number(JSON.parse(j.alarmDataJson).earlyWarningValue.split(",")[i])) {
                  if (Number(parseInt(item[1])) > Number(JSON.parse(j.alarmDataJson).alarmValue.split(",")[i])) {
                    statusArr.push("red")
                  } else {
                    statusArr.push("yellow")
                  }
                } else {
                  statusArr.push("green")
                }
              }
            })
          })
        }
      } else {
        dataArray.forEach(item => {
          this.measures.forEach(j => {
            if (key == j.measureNo) {
              if (Number(parseInt(item[1])) > Number(JSON.parse(j.alarmDataJson).earlyWarningValue)) {
                if (Number(parseInt(item[1])) > Number(JSON.parse(j.alarmDataJson).alarmValue)) {
                  statusArr.push("red")
                } else {
                  statusArr.push("yellow")
                }
              } else {
                statusArr.push("green")
              }
            }
          })
        })
      }
      this.drawStatusC(key, statusArr)
    },
    /*绘制测点圆点颜色*/

    drawStatusC(number, statusArr) {
      this.measures.forEach(i => {
        if (number === i.measureNo) {
          if (statusArr.indexOf("red") !== -1) {
            $("#statusC" + i.measureNo).css("background", "red")
          } else if (statusArr.indexOf("yellow") !== -1) {
            $("#statusC" + i.measureNo).css("background", "#DDAA00")
          } else {
            $("#statusC" + i.measureNo).css("background", "#00ff80")
          }
        }
      })
    },

    // 正常绘制画预览图表
    drawChart(key) {
      let myChart;
      if (!document.getElementById("data" + key)) {
        return
      }
      if (this.charts[key] == null) {
        myChart = echarts.init(document.getElementById("data" + key));
        this.charts[key] = myChart;
      } else {
        myChart = this.charts[key];
      }
      // myChart.clear()
      let option = this.miniOption();
      if (this.meassureData[key] == null) {
        return;
      }
      if (!this.meassureData[key].dataArray) {
        return
      }
      let dataArray = this.meassureData[key].dataArray;
      for (let i = 0; i < dataArray.length; i++) {
        option.series.push(
          {
            type: "line",
            showSymbol: false,
            data: dataArray[i],
            smooth: true
          }
        );
      }
      myChart.setOption(option, true);
    },
    miniOption() {
      let option = {
        grid: {
          top: "5%",
          left: "8%",
          right: "8%",
          bottom: "10%"
        },
        color: ["#FB4D4B", "#409EFF", "#6ED2B2"],
        xAxis: {
          type: "category",
          show: false,
        },
        yAxis: {
          type: "value",
          show: false,
          max: function(data) {
            if (data.max > 0) {
              return data.max * 1.1
            }
            return data.max * 0.9
          },
          min: function(data) {
            if (data.min > 0) {
              return data.min * 0.9
            }
            return data.min * 1.1
          }
        },
        series: []
      };
      return option;
    },

    // 绘制ShowType2预览图表start
    drawShowType2Chart() {
      this.$nextTick(() => {
        this.rightShowType2Arr.forEach(data => {
          if (!document.getElementById("rightShowType2MiniEcharts" + data.measureGroupId)) {
            return
          }
          if (!this.showType2Echarts) {
            this.showType2Echarts = echarts.init(document.getElementById("rightShowType2MiniEcharts" + data.measureGroupId));
          }

          let option = this.showType2MiniOption(data);
          this.showType2Echarts.setOption(option, true);
        })
      })
    },
    showType2MiniOption(obj) {
      if (obj.dayAngleValues && obj.initAngleValues && obj.dayDateList) {
        this.showType2MainEchartsData = obj
        let dayX = []
        let dayY = []
        let dayZ = []
        obj.dayAngleValues.forEach(data => {
          dayX.push(data[0] ? data[0] : 0)
          dayY.push(data[1] ? data[1] : 0)
          dayZ.push(data[2] ? data[2] : 0)
        })

        let initX = []
        let initY = []
        let initZ = []
        obj.initAngleValues.forEach(data => {
          initX.push(data[0] ? data[0] : 0)
          initY.push(data[1] ? data[1] : 0)
          initZ.push(data[2] ? data[2] : 0)
        })


        let option = {
          color: ["#FB4D4B", "#FF1613", "#FB604B", "#6ED2B2", "#6ED278", "#88D26E"],
          grid: {
            top: "2%",
            left: "8%",
            right: "8%",
            bottom: "2%"
          },
          xAxis: {
            type: "value",
            show: false,
          },
          yAxis: {
            type: "category",
            show: false,
            data: obj.dayDateList
          },
          series: [
            {
              name: "当天x",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: dayX,
              z: 2
            },
            {
              name: "当天y",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: dayY,
              z: 2
            },
            {
              name: "当天z",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: dayZ,
              z: 2
            },

            {
              name: "初始x",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: initX,
              z: 1
            },
            {
              name: "初始y",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: initY,
              z: 1
            },
            {
              name: "初始z",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: initZ,
              z: 1
            }
          ]
        };
        return option;
      } else {
        return {}
      }
    },
    openRightShowType2MainEcharts(data) {
      this.rightShowTypeDialogTitle = data.name
      this.rightShowTypeDialogObj = data
      this.rightShowTypeDialogVisible = true;
    },
    loadRightShowTypeEcharts() {
      let obj = this.rightShowTypeDialogObj
      let myChart = echarts.init(document.getElementById("mainChart"));
      let option = {}

      if (obj.dayAngleValues && obj.initAngleValues && obj.dayDateList) {
        let dayX = []
        let dayY = []
        let dayZ = []
        obj.dayAngleValues.forEach(data => {
          dayX.push(data[0] ? data[0] : 0)
          dayY.push(data[1] ? data[1] : 0)
          dayZ.push(data[2] ? data[2] : 0)
        })

        let initX = []
        let initY = []
        let initZ = []
        obj.initAngleValues.forEach(data => {
          initX.push(data[0] ? data[0] : 0)
          initY.push(data[1] ? data[1] : 0)
          initZ.push(data[2] ? data[2] : 0)
        })


        option = {
          color: ["#FB4D4B", "#FF1613", "#FB604B", "#6ED2B2", "#6ED278", "#88D26E"],
          legend: {
            right: 10,
            textStyle: {
              color: "#ffffff"
            }
          },
          tooltip: {
            trigger: "axis",
            padding: [10, 15],
            formatter: (data) => {
              let obj = {
                time: "",
                pointNames: "",
                index: "",
                dayAngleObj: {
                  x: 0,
                  y: 0,
                  z: 0
                },
                initAngleObj: {
                  x: 0,
                  y: 0,
                  z: 0
                },
                dayShiftObj: {
                  x: 0,
                  y: 0,
                  z: 0
                },
                initShiftObj: {
                  x: 0,
                  y: 0,
                  z: 0
                }
              }
              obj.pointNames = data[0].name
              for (let i = 0; i < data.length; i++) {
                if (data[i].seriesName == "当天角度x") {
                  obj.dayAngleObj.x = data[i].value
                }
                if (data[i].seriesName == "当天角度y") {
                  obj.dayAngleObj.y = data[i].value
                }
                if (data[i].seriesName == "当天角度z") {
                  obj.dayAngleObj.z = data[i].value
                }
                if (data[i].seriesName == "初始角度x") {
                  obj.initAngleObj.x = data[i].value
                }
                if (data[i].seriesName == "初始角度y") {
                  obj.initAngleObj.y = data[i].value
                }
                if (data[i].seriesName == "初始角度z") {
                  obj.initAngleObj.z = data[i].value
                }
              }
              let pointNamesArr = this.showType2MainEchartsData.pointNames
              for (let i = 0; i < pointNamesArr.length; i++) {
                if (pointNamesArr[i] == obj.pointNames) {
                  obj.index = i
                  break
                }
              }
              obj.time = this.showType2MainEchartsData.dayDateList[obj.index]

              obj.dayShiftObj.x = this.showType2MainEchartsData.dayShiftValues[obj.index][0]
              obj.dayShiftObj.y = this.showType2MainEchartsData.dayShiftValues[obj.index][1]
              obj.dayShiftObj.z = this.showType2MainEchartsData.dayShiftValues[obj.index][2]

              obj.initShiftObj.x = this.showType2MainEchartsData.initShiftValues[obj.index][0]
              obj.initShiftObj.y = this.showType2MainEchartsData.initShiftValues[obj.index][1]
              obj.initShiftObj.z = this.showType2MainEchartsData.initShiftValues[obj.index][2]

              let str = obj.pointNames + "<br/>"
              str += obj.time + "<br/>"
              str += "当天角度x：" + obj.dayAngleObj.x + "&nbsp;&nbsp;&nbsp;&nbsp;" + "初始角度x：" + obj.initAngleObj.x + "<br/>"
              str += "当天角度y：" + obj.dayAngleObj.y + "&nbsp;&nbsp;&nbsp;&nbsp;" + "初始角度y：" + obj.initAngleObj.y + "<br/>"
              str += "当天角度z：" + obj.dayAngleObj.z + "&nbsp;&nbsp;&nbsp;&nbsp;" + "初始角度z：" + obj.initAngleObj.z + "<br/>"
              str += "<br/>"
              str += "当天位移x：" + obj.dayShiftObj.x + "&nbsp;&nbsp;&nbsp;&nbsp;" + "初始位移x：" + obj.initShiftObj.x + "<br/>"
              str += "当天位移y：" + obj.dayShiftObj.y + "&nbsp;&nbsp;&nbsp;&nbsp;" + "初始位移y：" + obj.initShiftObj.y + "<br/>"
              str += "当天位移z：" + obj.dayShiftObj.z + "&nbsp;&nbsp;&nbsp;&nbsp;" + "初始位移z：" + obj.initShiftObj.z + "<br/>"
              return str
            },
          },
          grid: {
            top: "8%",
            left: "10%",
            right: "10%",
            bottom: "5%"
          },
          xAxis: {
            type: "value",
            show: true,
            axisLabel: {
              color: "#fff",
              fontSize: 12,
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
          yAxis: {
            type: "category",
            show: true,
            data: obj.pointNames,
            axisLabel: {
              color: "#fff",
              fontSize: 12,
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            }
          },
          series: [
            {
              name: "当天角度x",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: dayX,
              z: 2
            },
            {
              name: "当天角度y",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: dayY,
              z: 2
            },
            {
              name: "当天角度z",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: dayZ,
              z: 2
            },

            {
              name: "初始角度x",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: initX,
              z: 1
            },
            {
              name: "初始角度y",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: initY,
              z: 1
            },
            {
              name: "初始角度z",
              type: "line",
              smooth: true,
              showSymbol: false,
              data: initZ,
              z: 1
            }
          ]
        };
      }

      myChart.setOption(option, true);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },
    // 绘制ShowType2预览图表end
    formatDate(time) {
      let date = new Date(time)
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? ("0" + d) : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let mintues = date.getMinutes();
      mintues = mintues < 10 ? "0" + mintues : mintues;
      let seconds = date.getSeconds();
      seconds = seconds < 10 ? "0" + seconds : seconds;
      let milliSeconds = date.getMilliseconds();

      return y + "-" + m + "-" + d + "  " + h + ":" + mintues + ":" + seconds + "." + milliSeconds;
    },
    initMeasure() {
      this.measureNos = [];
      this.infoPics = [];
      this.popoverStatus = [];
      this.meassureData = {};
      for (let key in this.charts) {
        `+`
        this.charts[key].dispose();
      }
      this.charts = {};
    },
    getChart(info, measureNo, lable, norValue) {
      this.mainMeasureNo = measureNo;
      this.lableName = lable + "——" + measureNo;
      this.uniName = info.alias
      this.norValue = JSON.parse(norValue).normalValue
      this.chartDialogVisible = true;
    },
    loadChartData() {
      if (this.mainMeasureNo == null) {
        return;
      }
      let myChart = echarts.init(document.getElementById("mainChart"));
      let option = {
        title: {
          text: "正常值范围:" + this.norValue,
          left: "5%",
          textStyle: {
            color: "#E48F16",
            fontSize: "16",
            fontWeight: "bold"
          }
        },
        grid: {
          top: "12%",
          left: "5%",
          right: "8%",
          bottom: "15%",
          containLabel: true,
        },
        legend: {
          right: 10,
          textStyle: {
            color: "#ffffff"
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: (data) => {
            let str = data[0].name + "<br/>"
            data.forEach(item => {
              str += item.marker + item.seriesName + "：" + item.value[1] + (this.unitObj[item.seriesName] ? this.unitObj[item.seriesName] : "") + "<br/>"
            })
            return str
          },
        },
        // 自定义线条颜色，所描绘的线条会在这里选颜色渲染
        color: ["#FB4D4B", "#409EFF", "#6ED2B2"],
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
        },
        yAxis: {
          name: this.uniName,
          nameLocation: "end",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["rgba(245,250,255,0.5)"]
            }
          }
        },
        series: [],
        dataZoom: [
          {
            type: "slider",
            backgroundColor: "#ffffff",
            fillerColor: "#77787b",
            showDataShadow: false,
            height: 18,
            // left: '5%',
            bottom: 15,
            handleSize: "120%", // 手柄大小
            borderColor: "none",
            handleIcon: "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5M36.9,35.8h-1.3z M27.8,35.8 h-1.3H27L27.8,35.8L27.8,35.8z",// 画一个圆形
            handleStyle: {
              color: "#77787b",
              global: true,
              shadowBlur: 6,
              shadowColor: "rgba(123, 154, 204, 0.5)",
            }
          },
        ],
      };
      this.getAlertData()

      let legend = ["x轴", "y轴", "z轴"]

      let obj = this.meassureData[this.mainMeasureNo]
      if (obj.resData && obj.resData.objAlias) {
        let unitObj = {}
        let objAlias = obj.resData.objAlias.split(",")
        let unitAlias = obj.resData.unitAlias.split(",")
        let valShowIndex = []
        if (obj.resData.valShowIndex) {
          valShowIndex = obj.resData.valShowIndex.split(",")
        } else {
          objAlias.forEach((data, index) => {
            valShowIndex.push(index)
          })
        }

        legend = []
        valShowIndex.forEach((data, index) => {
          if (data > objAlias.length - 1) {
            return
          } else {
            legend.push(objAlias[data])
            unitObj[objAlias[data]] = unitAlias[index]
          }
        })
        this.unitObj = unitObj
      } else {
        // 特殊情况特殊处理
        if (this.mainMeasureNo == "06020101") {
          legend = ["温度", "湿度"]
        } else if (this.mainMeasureNo == "06070101") {
          legend = ["PM2.5", "PM10"]
        } else if (this.mainMeasureNo.startsWith("020202")) {
          legend = ["位移", "温度"]
        } else if (this.mainMeasureNo.startsWith("020101")) {
          legend = ["应变", "温度"]
        } else if (this.mainMeasureNo.startsWith("011201")) {
          legend = ["压力", "温度"]
        } else if (this.mainMeasureNo.startsWith("020102")) {
          legend = ["应变", "温度"]
        } else if (this.mainMeasureNo.startsWith("011001")) {
          if (this.mainMeasureNo.startsWith("01100101")) {
            legend = ["压力"]
          } else {
            legend = ["压力", "温度"]
          }
        } else if (this.mainMeasureNo.startsWith("010901")) {
          if (this.mainMeasureNo.startsWith("01090101")) {
            legend = ["索力"]
          } else {
            legend = ["索力", "温度"]
          }
        } else if (this.mainMeasureNo.startsWith("010701")) {
          if (this.mainMeasureNo.startsWith("01070101")) {
            legend = ["力"]
          } else {
            legend = ["力", "温度"]
          }
        } else if (this.mainMeasureNo.startsWith("010801")) {
          if (this.mainMeasureNo.startsWith("01080101")) {
            legend = ["轴力"]
          } else {
            legend = ["轴力", "温度"]
          }
        }
      }
      if (!this.meassureData[this.mainMeasureNo].dataArray) {
        return
      }
      let dataArray = this.meassureData[this.mainMeasureNo].dataArray;

      if (this.meassureData[this.mainMeasureNo].resData.valShowIndex) {
        let valShowIndex = this.meassureData[this.mainMeasureNo].resData.valShowIndex.split(",")
        for (let i = 0; i < valShowIndex.length; i++) {
          option.series.push(
            {
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2//设置线条粗细
                  }
                }
              },
              // symbolSize:2,   //设定实心点的大小
              symbol: "none",  //取消折点圆圈
              type: "line",
              smooth: true,
              name: legend[i],
              data: dataArray[valShowIndex[i]],
              markLine: {
                data: this.markLineData
              }
            }
          );
        }
      } else {
        dataArray.forEach((data, index) => {
          option.series.push(
            {
              itemStyle: {
                normal: {
                  lineStyle: {
                    width: 2//设置线条粗细
                  }
                }
              },
              // symbolSize:2,   //设定实心点的大小
              symbol: "none",  //取消折点圆圈
              type: "line",
              smooth: true,
              name: legend[index],
              data: data,
              markLine: {
                data: this.markLineData
              }
            }
          );
        })
      }

      myChart.setOption(option, true);
      window.onresize = myChart.resize;
    },
    /*绘制Echart的markLine*/
    getAlertData() {
      this.measures.forEach(i => {
        if (this.mainMeasureNo === i.measureNo) {
          JSON.parse(i.alarmDataJson).earlyWarningValue.split(",").forEach((item, index) => {
            let earlyWarning = {
              yAxis: item,
              label: {
                position: "end", // 表现内容展示的位置
                formatter: "预警值" + [index + 1],  // 标线展示的内容
                color: "#ff3726"  // 展示内容颜色
              },
              lineStyle: { type: "dashed", color: "#ff3726", width: 1 }
            }
            this.markLineData.push(earlyWarning)
          })
        }
      })
    },
  },
  //页面关闭时监听
  // 销毁监听webSocketUrl
  destroyed() {
    if (this.socket) {
      this.socket.close()
      this.socket = null
      this.viewer3D = null
      this.drawableContainer = null
    }
  },

}
</script>

<style>

#realTimeData .el-menu {
  background-color: unset;
}

#realTimeData .el-submenu__title i {
  color: #e68f02;
}

#realTimeData .el-submenu__title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.52);
}

#realTimeData .el-menu-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.52) !important;
}

#realTimeData .el-submenu__title:hover {
  background-color: #335abb !important;
  color: #000 !important;
}

#realTimeData .el-menu-item:hover {
  background-color: #335abb !important;
  color: #000 !important;
  border-bottom: none;
}

#realTimeData .el-menu-item.is-active {
  background-color: #335abb !important;
}

#realTimeData .el-submenu .el-menu {
  margin-left: 0;
  margin-right: 0;
}

#realTimeData .el-menu-item-group__title {
  padding: 0 0 0 20px;
}

/* 框架中.el-submenu .el-menu-item宽度min-width: 200px,最小宽度设置为150px,防止超出长度 */
#realTimeData .el-submenu .el-menu-item {
  min-width: 150px;
}

.leadTips {
  display: flex;
  justify-content: start;
  width: 300px;
  transform: translateY(-40px)
}

.leadTips img {
  display: inline-block;
  width: 49px;
  height: 49px
}

.leadText {
  display: block;
  background: green;
  color: #fff;
  padding: 10px 5px;
  font-size: 12px;
  cursor: pointer;
}

.lableState {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #00ff80;
}

</style>


<style scoped>
@import "../../assets/css/style.css";

.scroll_panel {
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 1000;
}

.scroll_panel button {
  width: 30px;
  text-align: center;
  padding: 5px
}

* {
  margin: 0;
  padding: 0
}

html, body {
  height: 100%
}


li {
  list-style: none;
}

.model_panel {
  width: 100%;
  height: 400px;
  flex: 1;
  position: relative;
}

.measureAlarmList {
  position: absolute;
  top: 20px;
  left: 20px;
  min-width: 250px;
  padding: 10px 15px;
  padding-bottom: 0;
  background: rgba(255, 255, 255, 0.5);
  z-index: 999;
  border-radius: 5px;
  max-height: 300px;
  overflow-y: auto;
}

.measureAlarmList > div {
  width: 100%;
  font-size: 15px;
  color: #D70000;
  margin-bottom: 10px;
  cursor: pointer;
}

.measureAlarmListInfo {
  width: 99%;
  max-height: 400px;
  overflow-y: auto;
  padding: 10px 15px;
  background-color: #001334;
  margin: auto auto 0 auto
}

.measureAlarmListInfo > div {
  width: 100%;
  font-size: 15px;
  color: #fb4d4b;
  margin-top: 10px;
  text-align: center
}

/*新增样式 下箭头*/
.downArrow {
  text-align: center;
  line-height: 16px;
  font-size: 20px;
  font-weight: bold;
  color: #FFFFFF;
}

.miniContent {
  height: 40%;
}

.miniCar {
  width: 100%;
  height: 100%;
}

.carouselItem {
  height: auto;
}

::-webkit-scrollbar {
  /*width: 0;宽度为0隐藏*/
  width: 0;
}

.miniCar {
  /*width:100%;*/
  /*max-height: 400px;*/
  /*border: 1px solid red;*/

  /*line-height: 300px;*/
  /*height: 100%;*/
  /* border: 1px saddlebrown solid; */
}

/*/deep/ .miniCar  .el-carousel__container{*/
/*  height: 100% !important;*/
/*  !*line-height: 300px;*!*/
/*}*/
/*.carouselItem{*/
/*  !*margin: auto;*!*/
/*  !* border: 1px springgreen solid; *!*/
/*}*/
/*/deep/ .miniCar  .el-carousel__arrow {*/
/*  background-color: rgba(55, 55, 66, .8);*/
/*  color: #FFF;*/
/*  position: absolute;*/
/*  top: 10rem;*/
/*  z-index: 10;*/
/*  -webkit-transform: translateY(-50%);*/
/*  transform: translateY(-50%);*/
/*  text-align: center;*/
/*  font-size: 16px;*/
/*}*/
.mini_chart_panel {
  width: 18%;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 10px;
}

.mini_chart_panel > img {
  width: 100%;
}

.mini_chart_panel > .chart_content {
  position: absolute;
  width: 100%;
  color: #FFFFFF;
}

.mini_chart {
  height: 4rem;
}

.mini_chart_panel1 {
  width: 32%;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 10px;
}

.mini_chart_panel1 > img {
  width: 100%;
}

.mini_chart_panel1 > .chart_content {
  position: absolute;
  width: 100%;
  color: #FFFFFF;
}

.mini_chart1 {
  height: 13rem;
}

.nav_menu {
  height: 100%;
  border: 2px solid #345fc7;
  margin-left: 30px;
  margin-right: 30px;
  overflow-y: auto;
}

/deep/ .nav_menu::-webkit-scrollbar {
  /*width: 0;宽度为0隐藏*/
  width: 0;
}

.nav_menu /deep/ .el-submenu__title {
  padding-left: 0 !important;
}

#realTimeData /deep/ .el-dialog {
  background: linear-gradient(
    -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
  border-radius: 2.5px 2.5px 0px 0px;
  transition: unset;
}


#realTimeData /deep/ .el-dialog__body {
  padding: 0.25rem 0;
}

#realTimeData /deep/ .el-dialog__title {
  text-align: center;
  font-size: 1.8rem;
  color: rgb(218, 217, 254);
  font-weight: bold;
  white-space: normal;
  word-break: normal;
}

#realTimeData /deep/ .el-dialog__headerbtn {
  background-color: #001334;
  padding: 0.25rem 0.25rem;
}

#realTimeData /deep/ .el-dialog__header {
  padding: 1.2rem 1.2rem 0.8rem;
}

/*/deep/ .el-dialog__footer{*/
/*  background-color: #001334;*/
/*  width: 99%;*/
/*  text-align: inherit;*/
/*  z-index: 2;*/
/*  margin: 0 auto 4px auto;*/
/*  padding: 0 0 4px 0;*/
/*}*/
#mainChart {
  margin: auto auto 0 auto;
  padding: 20px 0;
  background-color: #001334;
}

#njMain {
  margin: auto auto 0 auto;
  padding: 20px 0;
  background-color: #001334;
}

.changeLine {
  margin: auto auto auto auto;
  background-color: #001334;
  width: 99%;
  text-align: center;
}

.circularStatus {
  background: #00ff80;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

/*  左侧导航栏*/
.positon_relative {
  /*height: 100%;*/
  /*overflow-y: auto;*/
}

.showtype2title1 {
  width: 99%;
  margin: auto;
  padding: 15px 0;
  background: #001334;
  color: #fff;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.showtype2title1 > div:nth-child(1), .showtype2title1 > div:nth-child(3) {
  word-break: keep-all
}

.showtype2title1 > div:nth-child(2) {
  word-break: keep-all;
  margin: 0 5%
}

.showtype2title2 {
  width: 99%;
  margin: auto;
  background: #001334;
  color: #fff;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  justify-content: center
}

.showtype2title2 > div:nth-child(1), .showtype2title2 > div:nth-child(3) {
  word-break: keep-all
}

.showtype2title2 > div:nth-child(2) {
  word-break: keep-all;
  margin: 0 5%
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/real-time-data-normal.vue